import React from 'react';
import { Link } from 'react-router-dom';
import './WhyTalk.css';

export default function WhyTalk() {
  const services = [
    {
      number: '01',
      title: 'Build A Powerful Digital Presence',
      description: 'From branding to social media to performance marketing, we create a digital identity that makes your business stand out and stay memorable.'
    },
    {
      number: '02',
      title: 'Turn Attention Into Meaningful Engagement',
      description: 'We craft content and campaigns that attract the right audience, spark interaction, and build long-term customer relationships.'
    },
    {
      number: '03',
      title: 'Drive Measurable Growth & Real Conversions',
      description: 'Through data-driven strategies, targeted ads, and continuous optimisation, we help you generate leads, boost sales, and scale effectively.'
    },
    {
      number: '04',
      title: 'Provide End-to-end Marketing Support',
      description: 'Whether online or offline, we handle everything—strategy, execution, design, content, and analytics—so you can focus on running your business while we fuel your growth.'
    }
  ];

  return (
    <section className="why-talk-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="why-talk-content scroll-reveal">
              <h2 className="why-talk-title">
               REDIFINING DIGITAL EXCELLENCE<br />
                
              </h2>
              <div className="underline" />
              <p className="why-talk-description">
                We help brands navigate the new age marketing with clarity, creativity, and purpose. From creating powerful brand identities to executing high-coversion campaigns, we blend strategy, design content, and marketing to create experiences your audience truly remembers. </p>
              <Link to="/about#core-values" className="btn btn-know-more">KNOW MORE</Link>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="services-grid">
              {services.map((service, index) => (
                <div key={index} className=" scroll-reveal">
                  <div className="service-number">{service.number}</div>
                  
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
